// Module
var code = `<table class="table" ng-table="\$ctrl.holdsTable">

  <thead>
  <tr>
    <th>#</th>
    <th>Type</th>
    <th>Sub-type</th>
    <th>Amount</th>
    <th>Status</th>
    <th>Created on</th>
    <th>Remarks</th>
    <th>Auto release on</th>
    <th>Released on</th>
    <th></th>
  </tr>
  </thead>

  <tbody>
  <tr class="table__row--clickable"
      ng-repeat="item in \$ctrl.holdsTable.data"
      ng-click="\$ctrl.transactionClicked(item, \$event)"
      ng-class="{'selected': \$ctrl.selectedHoldId === item.id}">
    <td>{{ \$index+1 + (\$ctrl.holdsTable.page() - 1) * \$ctrl.holdsTable.count() }}</td>
    <td>{{ item.type | prettyEnum }}</td>
    <td>{{ item.subType | prettyEnum }}</td>
    <td>{{ item.amount | nxCurrency }}</td>
    <td>{{ item.status | prettyEnum }}</td>
    <td>{{ item.createdOn | prettyDate }}</td>
    <!-- Most recent action: a release overwrites the note shown; an update overwrites
         creationRemarks server-side. -->
    <td>{{ item.releaseRemarks || item.creationRemarks }}</td>
    <td>{{ item.autoReleaseOn | prettyDate }}</td>
    <td>{{ item.releasedOn | prettyDate }}</td>
    <td>
      <!-- Money Lock holds only: per NR-14 AC #5 CBS users may not edit Regular manual, Loan or
           Check Clearing holds, and never a released one. -->
      <button
        ng-if="'MANUAL' === item.type && item.status === 'ACTIVE' && 'MONEY_LOCK' === item.subType"
        command-access="UpdateManualHold"
        class="btn btn-primary"
        ng-click="\$ctrl.editHold(item)">
        Edit
      </button>
      <button
        ng-if="'MANUAL' === item.type && item.status === 'ACTIVE'"
        command-access="ReleaseManualHold"
        class="btn btn-primary"
        ng-click="\$ctrl.releaseHold(item)">
        Release
      </button>
      <button
        ng-if="'LOAN' === item.type && item.status === 'ACTIVE'"
        command-access="ReleaseLoanHold"
        class="btn btn-primary"
        ng-click="\$ctrl.releaseHold(item)">
        Release
      </button>
    </td>
  </tr>
  </tbody>

</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/product-holds/product-holds.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;